'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-shadow */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var input = function input() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var props = _ref.props;

  var Input = function Input(_ref2) {
    var value = _ref2.value;
    var onValue = _ref2.onValue;

    var onKeyUp = function onKeyUp(_ref3) {
      var key = _ref3.key;
      var value = _ref3.target.value;

      if (key === 'Enter') {
        onValue(parseValue(value));
      }
    };
    var onBlur = function onBlur(_ref4) {
      var value = _ref4.target.value;
      // eslint-disable-line react/prop-types
      onValue(parseValue(value));
    };
    var parseValue = function parseValue(v) {
      return value === parseFloat(value) ? parseFloat(v) : v;
    };

    return _react2.default.createElement('input', _extends({
      defaultValue: value,
      onKeyUp: onKeyUp,
      onBlur: onBlur,
      autoFocus: true
    }, props));
  };
  process.env.NODE_ENV !== "production" ? Input.propTypes = {
    value: _react2.default.PropTypes.any,
    onValue: _react2.default.PropTypes.func
  } : void 0;

  return Input;
};

exports.default = input;


//////////////////
// WEBPACK FOOTER
// ./~/react-edit/dist/input.js
// module id = 1268
// module chunks = 0